if (!customElements.get('selling-plan-selector')) {
  class SellingPlanSelector extends HTMLElement {
    constructor() {
      super();
      this.syncSellingPlan = this.syncSellingPlan.bind(this);
    }

    connectedCallback() {
      this.syncSellingPlan(); // Run once on load

      // Update on any click within the component
      this.addEventListener('click', this.syncSellingPlan);
    }

    syncSellingPlan() {
      const checkedOption = this.querySelector('[name="selling_plan_option"]:checked');
      const targetInput = this.querySelector('[name="selling_plan"][data-sub]');
      const priceDisplay = this.querySelector('[data-discount-price]');
      const percentageDisplay = this.querySelector('[data-discount-percentage]');

      if (checkedOption && targetInput && priceDisplay) {
        targetInput.value = checkedOption.value;

        // Parse discount JSON from the selected input
        const discountData = checkedOption.getAttribute('data-discount');
        let discountPercent = 0;

        try {
          const adjustments = JSON.parse(discountData);
          if (adjustments.length > 0) {
            const adjustment = adjustments[0];
            if (adjustment.value_type === 'percentage') {
              discountPercent = parseFloat(adjustment.value);
            }
          }
        } catch (e) {
          console.error('Error parsing discount data:', e);
        }

        // Get the base price in cents
        const basePriceCents = parseInt(priceDisplay.getAttribute('data-discount-price'), 10);
        if (isNaN(basePriceCents)) return;

        // Calculate discounted price
        const discountedPriceCents = Math.round(basePriceCents * (1 - discountPercent / 100));
        const discountedPriceDollars = (discountedPriceCents / 100).toFixed(2);

        // Update price and percentage display
        priceDisplay.innerText = `$${discountedPriceDollars}`;
        if (percentageDisplay) {
          percentageDisplay.innerText = discountPercent > 0 ? `${discountPercent}%` : '';
        }
      }
    }
  }

  customElements.define('selling-plan-selector', SellingPlanSelector);
}
